/* unplugin-vue-components disabled */import { render } from "./refundApproval.vue?vue&type=template&id=53d207a0&scoped=true"
import script from "./refundApproval.vue?vue&type=script&lang=js"
export * from "./refundApproval.vue?vue&type=script&lang=js"

import "./refundApproval.vue?vue&type=style&index=0&id=53d207a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d207a0"]])

export default __exports__